<template>
    <v-container fluid>
        <SaralaTable :model="model" :createRoute="{ name: 'popup.create' }" />
    </v-container>
</template>

<script>
import Popup from '@/models/settings/Popup'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        SaralaTable,
    },

    computed: {
        model() {
            return new Popup()
        },
    },
}
</script>

<style></style>
